import { useEffect } from 'react';
export function useKeyboardShortcuts(bindings) {
  useEffect(() => {
    function onKeyDown(event) {
      const key = [event.ctrlKey || event.metaKey ? 'mod' : '', event.shiftKey ? 'shift' : '', event.key.toLowerCase()].filter(Boolean).join('+');
      if (bindings[key]) { event.preventDefault(); bindings[key](); }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [bindings]);
}
